var _g, _text, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PDF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.693,
    height: 38.007,
    viewBox: "0 0 29.693 38.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_7085",
    "data-name": "Path 7085",
    transform: "translate(-1)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.75448799133301 37.00718307495117 L 6.93862771987915 37.00718307495117 C 4.215457439422607 37.00718307495117 1.999997615814209 34.79172515869141 1.999997615814209 32.06856155395508 L 1.999997615814209 5.938623428344727 C 1.999997615814209 3.215463399887085 4.215457439422607 1.000003457069397 6.93862771987915 1.000003457069397 L 15.00973415374756 1.000003457069397 C 19.05038070678711 4.640790462493896 25.92181587219238 10.21060752868652 29.69311714172363 13.20441341400146 L 29.69311714172363 32.06856155395508 C 29.69311714172363 34.79172515869141 27.47765731811523 37.00718307495117 24.75448799133301 37.00718307495117 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.938627243041992 2.000003814697266 C 4.766857147216797 2.000003814697266 2.999998092651367 3.766864776611328 2.999998092651367 5.938625335693359 L 2.999998092651367 32.06856536865234 C 2.999998092651367 34.24032211303711 4.766857147216797 36.00718307495117 6.938627243041992 36.00718307495117 L 24.75448799133301 36.00718307495117 C 26.9262580871582 36.00718307495117 28.69311714172363 34.24032211303711 28.69311714172363 32.06856536865234 L 28.69311714172363 13.68698310852051 C 24.93781852722168 10.69857025146484 18.58140182495117 5.536312103271484 14.62677955627441 2.000003814697266 L 6.938627243041992 2.000003814697266 M 6.938627243041992 3.814697265625e-06 L 15.39499855041504 3.814697265625e-06 C 19.38508796691895 3.626384735107422 26.62814712524414 9.502952575683594 30.69311714172363 12.7210636138916 L 30.69311714172363 32.06856536865234 C 30.69311714172363 35.34837341308594 28.0343074798584 38.00718307495117 24.75448799133301 38.00718307495117 L 6.938627243041992 38.00718307495117 C 3.658807754516602 38.00718307495117 0.9999980926513672 35.34837341308594 0.9999980926513672 32.06856536865234 L 0.9999980926513672 5.938625335693359 C 0.9999980926513672 2.6588134765625 3.658807754516602 3.814697265625e-06 6.938627243041992 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#053f7f"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "PDF-2",
    "data-name": "PDF",
    transform: "translate(4.672 30.096)",
    fill: "#053f7f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_63732",
    "data-name": "Line 63732",
    y2: 13.065,
    transform: "translate(14.847 1.782)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7086",
    "data-name": "Path 7086",
    d: "M13.065,0H0",
    transform: "translate(14.847 13.659)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.e703d68d1ae5bf7123dbb45dc2591c1b.svg";
export { ForwardRef as ReactComponent };